import React from 'react';
const ArrowDownSVG = ({ color = 'black', className }) => {
  return (
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.80808 0C0.0743255 0 -0.211375 0.347241 0.167204 0.772605L6.31246 7.68034C6.69199 8.10719 7.30845 8.10592 7.68706 7.68034L13.8323 0.772605C14.2118 0.345974 13.9255 0 13.1917 0L0.80808 0Z"
        fill={color}
      />
    </svg>
  );
};

export default ArrowDownSVG;
